import { InventoryTransactionProps, SaleOrderItemProps } from '@/types'
import { CatalogProductProps } from './catalog-product.type'
import { SupplierForecastProps } from './supplier-forecast.type'
import { ProductQualityCategoryEnum } from './supplier-order.type'
import { SupplierProps, SupplierWarehouseProps } from './supplier.type'

export enum SupplierProductPackageEnum {
  '25kg_bags' = '25kg_bags',
  'super_sacks' = 'super_sacks',
  'in_bulk' = 'in_bulk',
  'rolls' = 'rolls',
  'gaylord_boxes' = 'gaylord_boxes',
  '25kg_boxes' = '25kg_boxes',
}

export interface SupplierProductProps {
  uuid?: string
  supplierUuid?: string
  supplier?: SupplierProps
  catalogProduct?: CatalogProductProps
  catalogProductUuid?: string
  package?: keyof typeof SupplierProductPackageEnum
  minimumPurchaseQuantity?: number
  supplierWarehouseUuid?: string
  supplierWarehouse?: SupplierWarehouseProps
  minDeliveryDays?: number
  reference?: string
  totalQuantityUsed?: number
  category?: 'metais' | 'resinas_plasticas'
  saleOrderItems?: SaleOrderItemProps[]
  forecasts?: SupplierForecastProps[]
  inventoryTransactions?: InventoryTransactionProps[]
  createdAt?: string
  updatedAt?: string
}

export interface SupplierProductListWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: SupplierProductProps[]
}

export interface SupplierProductMetricsProps {
  totalQuantity: number
  totalQuantityUsed: number
}

export interface ForecastsAndInventoriesProps {
  quantity?: number
  cost?: number
  currency?: 'MXN' | 'USD'
  dollarExchangeRate?: string
  catalogProductUuid?: string
  forecastUuid?: string
  forecast?: SupplierForecastProps
  inventoryTransactionUuid?: string
  inventoryTransaction?: InventoryTransactionProps
  category?: keyof typeof ProductQualityCategoryEnum
  supplierProduct?: SupplierProductProps
  createdAt?: string
  updatedAt?: string
}

export interface ForecastsAndInventoriesWithPagesProps {
  count?: number
  next?: string
  previous?: string
  results?: ForecastsAndInventoriesProps[]
}
